import { render, staticRenderFns } from "./DeclineIcon.vue?vue&type=template&id=d027d410"
import script from "./DeclineIcon.vue?vue&type=script&lang=js"
export * from "./DeclineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports